const mutations = {
    SAVE_SUPPLIER_DETAILS(state, data) {
        localStorage.setItem('supplier', JSON.stringify(data));
        state.supplier = data;
    },
    SET_ROUTE_PATH(state, data) {
      localStorage.setItem('routPath', data);
      state.routPath = data;
    },
    SET_METHOD(state, data) {
      localStorage.setItem('method', data);
      state.method = data;
    },
    SET_SHOW_SIDEBAR(state, status) {
      state.showSidebar = status;
    },
    SET_SUPPLIER_ID(state, data) {
      localStorage.setItem('supplierId', data);
      state.supplierId = data;
    },
    SET_PRODUCT_TYPE(state, data) {
      localStorage.setItem('marketPlaceProductType', data);
      state.marketPlaceProductType = data;
    },
    SET_TRANSACTION_ID(state, data) {
      localStorage.setItem('transactionID', data);
      state.transactionID = data;
    },
    SET_TRANSACTION_AMOUNT(state, data) {
      localStorage.setItem('transactionAmount', data);
      state.transactionAmount = data;
    },
    SET_INVOICE_NUMBER(state, data) {
      localStorage.setItem('invoiceNumber', data);
      state.invoiceNumber = data;
    },
    SET_UPLOADED_DOCUMENTS(state, documents) {
      localStorage.setItem('uploadedDocuments', JSON.stringify(documents));
      state.uploadedDocument = documents;
    },
    // ADD_UPLOADED_DOCUMENT(state, document) {
    //   state.uploadedDocument.push(document);
    //   localStorage.setItem('uploadedDocuments', JSON.stringify(state.uploadedDocument));
    // },
    ADD_UPLOADED_DOCUMENT(state, document) {
      state.uploadedDocument.push(document);
      // Store only metadata (name, displayName, size) in localStorage
      const metadata = state.uploadedDocument.map(doc => ({
        displayName: doc.displayName,
        name: doc.name,
        size: doc.size,
      }));
      try {
        localStorage.setItem('uploadedDocuments', JSON.stringify(metadata));
      } catch (e) {
        console.error('Storage quota exceeded. Cannot save to localStorage.', e);
      }
    },
    REMOVE_UPLOADED_DOCUMENT(state, index) {
      state.uploadedDocument.splice(index, 1);
      localStorage.setItem('uploadedDocuments', JSON.stringify(state.uploadedDocument));
    },
    CLEAR_UPLOADED_DOCUMENTS(state) {
      state.uploadedDocument = [];
      localStorage.removeItem('uploadedDocuments');
    },
    SAVE_PAYMENT_METHOD(state, method) {
      state.paymentMethod = method;
      localStorage.setItem('paymentMethod', JSON.stringify(method));
    }
};
export default mutations;
